module.exports = __webpack_public_path__ + "img/rfw.c8f0a81.png";